import React from 'react';

const Manual = () => (
  <div className="prose max-w-none">
    <h2 className="text-2xl font-bold mb-6">
      SAIL TRACK Takip &amp; Dinleme Cihazı Kullanım Kılavuzu
    </h2>

    <p className="mb-4">
      Cihazı kullanabilmek için Turkcell bayilerinden bir SIM kart temin edilmelidir.
      Satın alınan SIM kartın PIN kodunun iptal edilmesi gerekmektedir.
    </p>

    <fieldset
      style={{
        padding: '15px',
        border: 'none',
      }}
    >
      <legend
        style={{
          margin: '0px 15px',
          width: 'auto',
          padding: '0 5px',
          fontSize: '23px',
        }}
      >
        Sim Kart Nasıl Takılır?
      </legend>
      <img
        src="https://www.sailguvenlik.com/images/sailtrack-simkart-takilis.gif"
        alt="Sim kart takılış görseli"
        style={{
          width: '380px',
          margin: 'auto',
          borderRadius: '10px',
          maxWidth: '90%',
        }}
      />
    </fieldset>

    <h2
      className="text-xl font-bold mt-6 mb-4"
      style={{
        color: '#1c95d2',
      }}
    >
      Başlangıç Ayarları
    </h2>

    <div className="space-y-2 mb-6">
      <p
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          flexWrap: 'wrap',
        }}
      >
        <strong>Sail Track Mobil Uygulaması:</strong>
      </p>

      <p>● Cihazı açmak için üzerindeki butona 5 saniye basılı tutun.</p>

      <p>
        ● Google Play ya da App Store&apos;dan
        <strong> &quot;Sail Track&quot; </strong>
        yazarak
        uygulamamızı indirin.
      </p>

      <p>
        ● Uygulama başlangıcında sunucu ayarlarını yapılandırmak için ekrana gelen
        AYARLA butonuna hiçbir ayarı değiştirmeden seçip ilerleyiniz.
        (İlk kurulum için geçerlidir.)
      </p>

      <p>
        ● Ürün ile beraber gelen Kullanıcı adı ve şifreyi, gelen ekrana giriniz.
      </p>
    </div>

    <div
      style={{
        textAlign: 'left',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
      }}
    >
      <img
        src="https://www.sailguvenlik.com/media/sailtrack/mobil-kullanici-girisi.jpg"
        alt="Mobil kullanıcı girişi"
        style={{
          width: '417px',
          maxWidth: '100%',
          objectFit: 'contain',
        }}
      />
      <img
        src="https://www.sailguvenlik.com/media/sailtrack/login-screen.jpg"
        alt="Giriş ekranı"
        style={{
          width: '417px',
          maxWidth: '100%',
        }}
      />
    </div>

    <h2
      className="text-xl font-bold mt-6 mb-4"
      style={{
        color: '#1c95d2',
      }}
    >
      Temel Komutlar:
    </h2>

    <div className="bg-gray-50 p-4 rounded-lg mb-6">
      <ul className="list-none space-y-2">
        <li>
          <strong>000#sizin telefon numaranız# →</strong>
          Bunu işlemi yaptığınız zaman cihazı
          aradığınızda dinleme yapabilirsiniz
        </li>
        <li>
          <strong>222#</strong>
          {' '}
          - Hafıza kartına kaydetmeyi başlatır
        </li>
        <li>
          <strong>333#</strong>
          {' '}
          - Sesli geri aramayı aktif hale getirir. Cihaz ses algıladığında
          sizi arar.
        </li>
        <li>
          <strong>555#</strong>
          {' '}
          - Geri arama ve kayıt fonksiyonlarını devre dışı bırakır.
        </li>
      </ul>
    </div>

    <p className="bg-yellow-50 p-4 rounded-lg mb-6">
      <strong>
        NOT: Bu komutları cihazın içerisine taktığınız hatta SMS ile göndereceksiniz.
      </strong>
    </p>

    <div
      style={{
        textAlign: 'left',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
      }}
    >
      <img
        src="https://www.sailguvenlik.com/media/sailtrack/phone-code333.jpg"
        alt="333 kod"
        style={{
          width: '300px',
          maxWidth: '100%',
          objectFit: 'contain',
          borderRadius: '7px',
          marginTop: '10px',
        }}
      />
      <img
        src="https://www.sailguvenlik.com/media/sailtrack/temel-code222.jpg"
        alt="222 kod"
        style={{
          width: '300px',
          maxWidth: '100%',
          objectFit: 'contain',
          borderRadius: '7px',
          marginTop: '10px',
        }}
      />
      <img
        src="https://www.sailguvenlik.com/media/sailtrack/temel-code555.jpg"
        alt="555 kod"
        style={{
          width: '300px',
          maxWidth: '100%',
          objectFit: 'contain',
          borderRadius: '7px',
          marginTop: '10px',
        }}
      />
    </div>

    <h2
      className="text-xl font-bold mt-6 mb-4"
      style={{
        color: '#1c95d2',
      }}
    >
      Sesle ve Hareketle Geri Arama Özelliğini Kapatma
    </h2>

    <p className="mb-4">
      Cihazda aktif olan sesle veya hareketle geri arama özelliklerinden birini ya da
      her ikisini kapatmak için, telefonunuzdan cihaza
      <strong> 555# </strong>
      komutunu içeren bir SMS göndermeniz gerekmektedir.
    </p>

    <p className="bg-yellow-50 p-4 rounded-lg mb-6">
      <strong>
        NOT: 555# komutunu gönderdiğinizde, ses kaydı da durdurulacaktır.
        Eğer aktif bir ses kaydınız varsa, kaydı yeniden başlatmanız gerekmektedir.
      </strong>
    </p>

    <h2
      className="text-xl font-bold mt-6 mb-4"
      style={{
        color: '#1c95d2',
      }}
    >
      Şarj Süresini Uzatma ve Konum Frekansı Ayarlama
    </h2>

    <p className="mb-4">
      Varsayılan olarak konum frekansı 1 dakikaya ayarlandığı için uygulama üzerinde
      cihaz, haritadaki konumunu her dakika günceller. Bu şekilde ürün fazla şarj
      tüketebilir.
    </p>

    <div className="bg-blue-50 p-4 rounded-lg mb-6">
      <ul className="list-disc pl-5 space-y-2">
        <li>
          Şarj süresini uzatmak için konum güncelleme sıklığını artırabilirsiniz.
        </li>
        <li>
          Konum frekansı 5-10 dakikaya ayarlandığında, cihazın şarj süresi ortalama
          2-3 güne kadar uzayabilir.
        </li>
        <li>
          Konum frekansını minimum 1, maksimum 120 dakikaya kadar yükseltebilirsiniz.
        </li>
      </ul>
    </div>

    <div
      style={{
        textAlign: 'left',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
      }}
    >
      <img
        src="https://www.sailguvenlik.com/media/sailtrack/konum-tasarruf.jpg"
        alt="Konum tasarruf"
        style={{
          width: '400px',
          maxWidth: '100%',
          objectFit: 'contain',
        }}
      />
      <img
        src="https://www.sailguvenlik.com/media/sailtrack/konum-veri-1.jpg"
        alt="Konum veri 1"
        style={{
          width: '417px',
          maxWidth: '100%',
          objectFit: 'contain',
        }}
      />
    </div>

    <h2
      className="text-xl font-bold mt-6 mb-4"
      style={{
        color: '#1c95d2',
      }}
    >
      Cihazın Dinleme Fonksiyonu
    </h2>

    <div className="space-y-2 mb-6">
      <p>
        ● Dinleme yapabilmek için
        <strong> &quot;kendi cep numaranızı&quot; </strong>
        uygulama üzerinden cihaza tanımlamalısınız.
      </p>
      <p>
        ● Numara tanımlaması yapılmadığı takdirde tanımlı numara dışındaki numaralara
        cihaz cevap vermeyecek ve meşgul çalacaktır.
      </p>
      <p>● Cihaz sadece tanımlama yapılan numara tarafından dinlenebilir.</p>
    </div>

    <h2
      className="text-xl font-bold mt-6 mb-4"
      style={{
        color: '#1c95d2',
      }}
    >
      SOS Özelliği (Acil Durum)
    </h2>

    <div className="space-y-2 mb-6">
      <p>Haritada Cihaz Seç → Komut tıkla → Sos numarası</p>
      <p className="bg-red-50 p-4 rounded-lg">
        <strong>
          NOT: Cihaz için aldığınız hattın numarasını girmeyiniz.
        </strong>
      </p>
    </div>

    <div
      style={{
        textAlign: 'left',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
      }}
    >
      <img
        src="https://www.sailguvenlik.com/media/sailtrack/konum-tasarruf.jpg"
        alt="Konum tasarruf"
        style={{
          width: '400px',
          maxWidth: '100%',
          objectFit: 'contain',
        }}
      />
      <img
        src="https://www.sailguvenlik.com/media/sailtrack/sos-numara.jpg"
        alt="SOS numara"
        style={{
          width: '417px',
          maxWidth: '100%',
          objectFit: 'scale-down',
        }}
      />
    </div>

    <h2
      className="text-xl font-bold mt-6 mb-4"
      style={{
        color: '#1c95d2',
      }}
    >
      Cihazın Girilen Numarayı Araması
    </h2>

    <div className="space-y-2 mb-6">
      <p>● Gelen aramayı yanıtlayın.</p>
      <p>● Arama sırasında herhangi bir sorun yoksa aramayı sonlandırın.</p>
      <p>
        ● Cihazın girilen numarayı arayabilmesi, numaranın doğru kaydedildiğini ve
        dinleme işleminin başarıyla gerçekleştirilebileceğini gösterir.
      </p>
    </div>

    <p className="bg-red-50 p-4 rounded-lg">
      <strong>
        Bu adımları tamamladıktan sonra, cihaza taktığınız hattın numarasını
        aradığınızda, cihaz otomatik olarak çağrınıza yanıt verecektir.
      </strong>
    </p>

    <h2
      className="text-xl font-bold mt-6 mb-4"
      style={{
        color: '#1c95d2',
      }}
    >
      Kayıt Başlatma ve Durdurma
    </h2>

    <div className="space-y-2 mb-6">
      <p>
        ● Ortamdaki sesleri hafıza kartına kaydetmek için, uygulama üzerinden
        tanımladığınız numaradan SMS göndermeniz gerekmektedir.
        (Cihaz maksimum 32 GB hafıza kartı destekler.)
      </p>
      <p>
        ● Telefonunuzun SMS bölümüne girin. Alıcı kısmına cihazın içindeki numarayı yazın.
        Mesaj içeriğine
        <strong> 222# </strong>
        yazarak gönderin.
      </p>
      <p>
        ● Cihazdan &quot;sound record&quot; yanıtını aldığınızda kayıt işlemi
        başlamış demektir.
      </p>
    </div>

    <h2
      className="text-xl font-bold mt-6 mb-4"
      style={{
        color: '#1c95d2',
      }}
    >
      Kaydı Durdurma:
    </h2>

    <div className="space-y-2 mb-6">
      <p>
        ● Telefonunuzun SMS bölümüne girin. Alıcı kısmına cihazın içindeki numarayı yazın.
      </p>
      <p>
        ● Mesaj içeriğine
        <strong> 555# </strong>
        yazarak gönderin. Cihazdan &quot;turn off all function&quot; yanıtını
        aldığınızda kayıt işlemi duracaktır.
      </p>
    </div>

    <div
      style={{
        textAlign: 'left',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
      }}
    >
      <img
        src="https://www.sailguvenlik.com/media/sailtrack/temel-code222.jpg"
        alt="222 kod"
        style={{
          width: '300px',
          maxWidth: '100%',
          objectFit: 'contain',
          borderRadius: '7px',
          marginTop: '10px',
        }}
      />
      <img
        src="https://www.sailguvenlik.com/media/sailtrack/temel-code555.jpg"
        alt="555 kod"
        style={{
          width: '300px',
          maxWidth: '100%',
          objectFit: 'contain',
          borderRadius: '7px',
          marginTop: '10px',
        }}
      />
    </div>

    <h2
      className="text-xl font-bold mt-6 mb-4"
      style={{
        color: '#1c95d2',
      }}
    >
      Ses ve Hareket ile Geri Dönüş Özelliği
    </h2>

    <div className="space-y-2 mb-6">
      <p>
        ● Bu özellik aktif olduğunda, cihaz ortamdaki sesi algıladığında veya
        hareket ettiğinde tanımlanan numarayı otomatik olarak arayarak ortam
        seslerini dinlemenizi sağlar.
      </p>
      <p>
        ● Özelliği kullanabilmek için öncelikle geri dönüş yapılacak numarayı
        cihaza tanımlamanız gerekmektedir. Bunun için: Telefonunuzdan, cihaza
        takılı olan numaraya 000#kendinumaranız# şeklinde bir SMS gönderin.
      </p>
    </div>

    <p className="bg-red-50 p-4 rounded-lg">
      <strong>
        Numara tanımlandıktan sonra özelliği aktif etmek için aşağıdaki
        komutları kullanabilirsiniz:
      </strong>
    </p>

    <div className="space-y-2 mb-6">
      <p>
        ●
        <strong> Sesle geri dönüşü aktif etmek için: </strong>
        333# yazıp cihaza SMS gönderin.
      </p>
      <p>
        ●
        <strong> Hareketle geri dönüşü aktif etmek için: </strong>
        777# yazıp cihaza SMS gönderin.
      </p>
    </div>

    <div
      style={{
        textAlign: 'left',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
      }}
    >
      <img
        src="https://www.sailguvenlik.com/media/sailtrack/phone-code333.jpg"
        alt="333 kod"
        style={{
          width: '300px',
          maxWidth: '100%',
          objectFit: 'contain',
          borderRadius: '7px',
          marginTop: '10px',
        }}
      />
      <img
        src="https://www.sailguvenlik.com/media/sailtrack/phone-code777.jpg"
        alt="777 kod"
        style={{
          width: '300px',
          maxWidth: '100%',
          objectFit: 'contain',
          borderRadius: '7px',
          marginTop: '10px',
        }}
      />
    </div>
  </div>
);

export default Manual;
